import Swiper from 'swiper/bundle';

function slideConteudo() {
	document.querySelectorAll(".slide-cursosETreinamentos-container").forEach(slide => {
		new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 10,
			grabCursor: 'true',
			autoplay: { delay: 5000 },

			navigation: {
				nextEl: slide.querySelector(".swiper-button-next"),
				prevEl: slide.querySelector(".swiper-button-prev"),
			}
		});
	});
}

if (document.querySelectorAll(".slide-cursosETreinamentos-container")) {
	slideConteudo();
}

function slideConteudoPromocao() {
	document.querySelectorAll(".slide-cursosETreinamentosPromocao-container").forEach(slide => {
		new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 10,
			grabCursor: 'true',
			autoplay: { delay: 5000 },

			navigation: {
				nextEl: slide.querySelector(".swiper-button-next"),
				prevEl: slide.querySelector(".swiper-button-prev"),
			}
		});
	});
}

if (document.querySelectorAll(".slide-cursosETreinamentosPromocao-container")) {
	slideConteudoPromocao();
}
